(function () {
  'use strict';

  var platformUrls = {
    Instagram: 'https://www.instagram.com/',
    TikTok: 'https://www.tiktok.com/'
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-gd-product-share]').forEach(function (bar) {
      if (bar.dataset.gdShareBound) return;
      bar.dataset.gdShareBound = 'true';
      var title = bar.dataset.gdShareTitle || 'Produto';
      var status = bar.querySelector('[data-gd-share-status]');
      var fallback = bar.querySelector('[data-gd-share-fallback]');
      var open = bar.querySelector('[data-gd-share-open]');

      function productUrl() {
        var raw = bar.dataset.gdShareUrl || window.location.href;
        try {
          var url = new URL(raw, window.location.origin);
          url.hash = '';
          return url.toString();
        } catch (error) {
          return window.location.href.split('#')[0];
        }
      }

      function resetFeedback() {
        if (status) { status.hidden = true; status.textContent = ''; }
        if (fallback) { fallback.hidden = true; fallback.value = ''; }
        if (open) { open.hidden = true; open.removeAttribute('href'); }
      }

      function offerPlatform(channel) {
        if (!open) return;
        open.href = platformUrls[channel];
        open.textContent = 'Abrir ' + channel;
        open.hidden = false;
      }

      function copyFallback(url, channel) {
        function done(copied) {
          if (status) {
            status.hidden = false;
            status.textContent = copied
              ? 'Link copiado. Abra ' + channel + ' para colar.'
              : 'Não foi possível copiar. Selecione o link abaixo para usar no ' + channel + '.';
          }
          if (!copied && fallback) {
            fallback.hidden = false;
            fallback.value = url;
            fallback.focus();
            fallback.select();
          }
          offerPlatform(channel);
        }
        if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
          done(false);
          return;
        }
        try {
          Promise.resolve(navigator.clipboard.writeText(url)).then(function () { done(true); }, function () { done(false); });
        } catch (error) { done(false); }
      }

      function share(button) {
        var channel = button.dataset.gdShareApp;
        var url = productUrl();
        resetFeedback();
        if (typeof navigator.share === 'function') {
          try {
            // Call share synchronously from the click to preserve transient user activation.
            Promise.resolve(navigator.share({ title: title, text: title, url: url })).catch(function (error) {
              if (!error || error.name !== 'AbortError') copyFallback(url, channel);
            });
            return;
          } catch (error) { /* Fall back to a link the visitor can paste. */ }
        }
        copyFallback(url, channel);
      }

      bar.querySelectorAll('[data-gd-share-direct]').forEach(function (link) {
        var url = productUrl();
        if (link.dataset.gdShareDirect === 'whatsapp') {
          link.href = 'https://wa.me/?text=' + encodeURIComponent(title + ' — ' + url);
        } else if (link.dataset.gdShareDirect === 'facebook') {
          link.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
        }
      });

      bar.querySelectorAll('[data-gd-share-app]').forEach(function (button) {
        button.addEventListener('click', function () { share(button); });
      });
      if (fallback) fallback.addEventListener('focus', function () { fallback.select(); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();